import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import { VIEWS_LOADING, VIEWS_SUCCESS, VIEWS_FAILURE } from './constants';
import { createReducer } from './utils';

const defaultState = {
  loading: false,
  views: [],
  errorMessage: null,
};

// reducer
export const reducer = createReducer(defaultState, {
  [VIEWS_LOADING]: handleRequest,
  [VIEWS_SUCCESS]: handleAvailable,
  [VIEWS_FAILURE]: handleUnavailable,
});

// actions
export function getViews() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const keyState = 'views';
    const loadingName = 'loading';
    dispatch({ type: VIEWS_LOADING, payload: { loadingName } });
    try {
      const response = await dataSource.requestViews();
      dispatch({ type: VIEWS_SUCCESS, payload: { keyState, data: response, loadingName } });
    } catch (error) {
      console.log('getViews error', error);
      dispatch({ type: VIEWS_FAILURE, payload: { keyState, loadingName, defaultState: [] } });
    }
  };
}
